import './Footer.css';
import DiscordLogo from '../../assets/DiscordLogo.png';
import InstaLogo from '../../assets/InstaLogo.png';
import YoutubeLogo from '../../assets/YoutubeLogo.png';
import LinkedinLogo from '../../assets/LinkedinLogo.png';

const Footer = () =>{
    return(
        <footer>
        <ul className="social-handles">
          <li><a href="https://www.instagram.com/premkumarsingh511/" target='_blank'><img src={InstaLogo} /></a></li>
          <li><a href="https://www.linkedin.com/in/pr3mkum4r"><img src={LinkedinLogo} /></a></li>
          <li><a href="https://discord.com/users/hybridgamer410#9771" target='_blank'><img src={DiscordLogo} /></a></li>
          <li><a href="https://www.youtube.com/@gamerslife4107" target='_blank'><img src={YoutubeLogo} /></a></li>
        </ul>
      </footer>
    )
}

export default Footer;